<template src="./template.html"></template>

<script setup>
import { onMounted, computed } from 'vue'
import CartVoucherBlock from '@/app/Checkout/components/common/CartVoucherBlock/index.vue'
import ClubPoints from '@/app/Checkout/components/desktop/ClubPoints/index.vue'
import Disclaimer from '@/app/Checkout/components/desktop/Disclaimer/index.vue'
import FreeSamplesBlock from '@/app/Checkout/components/common/FreeSamplesBlock/index.vue'
import OrderSummary from '@/app/Checkout/components/desktop/OrderSummary/index.vue'
import NewsletterSubscriptionToggle from '@/app/Checkout/components/desktop/NewsletterSubscriptionToggle/index.vue'
import { useCart } from "@/app/Checkout/composables/useCart"
import { useAuth } from '@/app/Checkout/composables/useAuth'
import { useUser } from '@/app/Checkout/composables/useUser'
import { useFreeSamples } from "@/app/Checkout/composables/useFreeSamples"

const emit = defineEmits(["submit"])

const { cart } = useCart()
const { isLoggedIn } = useAuth()
const { allowedFreeSamples } = useFreeSamples()
const { user, isNewsletterSubscribed, getNewsletter } = useUser()
const showClubPoints = computed(() => user.value?.club_member && cart.value?.club_points)
const showNewsletterToggle = computed(() => !isLoggedIn.value || !isNewsletterSubscribed.value)

onMounted(async () => {
    await getNewsletter()
})
</script>
